import dayjs from 'dayjs'

export const today = dayjs().toDate()
export const tomorrow = dayjs().add(1, 'day').toDate()
